<template>
  <div>
    <header class="page-header">
      <div class="header-content">
        <div class="header-logo">
          <img :src="require('./images/logo.png')" />
          <h1>商客合一销售顾问版</h1>
        </div>
        <a-anchor :affix="false" wrapper-class="top-anchor">
          <a-anchor-link href="#top" title="首页" />
          <a-anchor-link href="#strength" title="优势" />
          <a-anchor-link href="#product" title="产品" />
        </a-anchor>
      </div>
    </header>
    <main class="main-content" id="top">
      <div class="slogan">
        <div class="data-container">
          <div class="item">
            <div class="number">5000万</div>
            <div class="desc">会员数量近</div>
          </div>
          <div class="split-line"></div>
          <div class="item">
            <div class="number">500家</div>
            <div class="desc">大型数字化门店近</div>
          </div>
          <div class="split-line"></div>
          <div class="item">
            <div class="number">TOP1</div>
            <div class="desc">APP获Trustdata母婴电商类</div>
          </div>
          <div class="split-line"></div>
          <div class="item">
            <div class="number">6000家</div>
            <div class="desc">合作中品牌超</div>
          </div>
        </div>
      </div>
      <div class="about">
        <div class="title">关于孩子王</div>
        <div class="content">
          孩子王是一家数据驱动、基于用户关系经营的创新型新家庭全渠道服务商采用深度会员模式，全渠道为会员提供一站式母婴商品解决方案、育儿成长服务及社交互动创立11年，已累计服务3500万会员，是国内母婴童商品零售与增值服务的知名品牌。
        </div>
      </div>
      <div class="strength" id="strength">
        <div class="info">
          <h3>孩子王旗下智慧营销平台</h3>
          <span>建立连接品牌商和公域导购员，资源共享，互利共赢，品牌深度融合的智慧工具产品矩阵</span>
        </div>
        <img :src="require('./images/strength.png')" />
      </div>
      <div class="product" id="product">
        <div class="product-bg">
          <h3>我们的产品</h3>
        </div>
        <div class="product-item-wrapper">
          <div class="product-item">
            <h5>核心关注</h5>
            <img :src="require('./images/product1.png')" />
          </div>
          <div class="product-item">
            <h5>任务通知</h5>
            <img :src="require('./images/product2.png')" />
          </div>
          <div class="product-item">
            <h5>营销工具</h5>
            <img :src="require('./images/product3.png')" />
          </div>
        </div>
      </div>
    </main>
    <kw-common-pc-footbar></kw-common-pc-footbar>
  </div>
</template>
<script>
import { Anchor } from 'ant-design-vue'
export default {
  components: {
    [Anchor.name]: Anchor,
    [Anchor.Link.name]: Anchor.Link
  },
  created() {
    document.title = '商客合一销售顾问版'
  }
}
</script>

<style lang="scss" scoped>
  .page-header {
    position: fixed;
    z-index: 1;
    width: 100%;
    background: #284AEE;
    height: 80px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .header-content {
      width: 1140px;
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .header-logo {
        display: flex;
        align-items: center;
      }
      img {
        width: 57px;
        height: 57px;
        margin-right: 20px;
      }
      h1 {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #FFFFFF;
        letter-spacing: 0;
      }
    }
  }
  .top-anchor {
    background: none;
    padding: 0;
    margin: 0;
    height: 80px;
    width: 260px;
    /deep/.ant-anchor {
      display: flex;
      margin-top: 30px;
      justify-content: space-between;
    }
    /deep/.ant-anchor-ink {
      display: none;
    }
    /deep/.ant-anchor-link-title {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #FFFFFF;
      letter-spacing: 0;
      padding: 0 0 15px 0;
      cursor: pointer;
    }
    /deep/.ant-anchor-link {
      padding: 0;
    }
    /deep/.ant-anchor-link-title-active {
      border-bottom: 3px solid #D8D8D8;
    }
  }
  .main-content {
    padding-top: 80px;
    .slogan {
      position: relative;
      width: 100%;
      height: 634px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      background-image: url('./images/top-bg.png');
      display: flex;
      justify-content: center;
      .data-container {
        position: absolute;
        width: 1140px;
        height: 187px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-image: url('./images/data-bg.png');
        top: 354px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .number {
            font-family: PingFangSC-Semibold;
            font-size: 40px;
            color: #1C5AD4;
            letter-spacing: 0;
            margin-bottom: 15px;
          }
          .desc {
            opacity: 0.8;
            font-family: PingFangSC-Regular;
            font-size: 24px;
            color: #4074DB;
            letter-spacing: 0;
          }
        }
        .split-line {
          width: 2px;
          height: 64px;
          opacity: 0.2;
          background: #3A74BA;
        }
      }
    }
    .about {
      width: 100%;
      height: 422px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      background-image: url('./images/about.png');
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 50px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 33px;
      }
      .content {
        width: 917px;
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #FFFFFF;
        letter-spacing: 1px;
        text-align: center;
        line-height: 36px;
      }
    }
    .strength {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 92px;
        margin-bottom: 50px;
        h3 {
          font-family: PingFangSC-Semibold;
          font-size: 50px;
          color: #262626;
          letter-spacing: 0;
          text-align: center;
          margin-bottom: 22px;
        }
        span {
          font-family: PingFangSC-Regular;
          font-size: 26px;
          color: #767676;
          letter-spacing: 0;
          text-align: center;
        }
      }
      img {
        width: 1088px;
        height: 491px;
        margin-bottom: 50px;
      }
    }
    .product {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding-bottom: 370px;
      .product-bg {
        width: 100%;
        height: 682px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-image: url('./images/product-bg.png');
        h3 {
          font-family: PingFangSC-Semibold;
          font-size: 50px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          padding-top: 60px;
        }
      }
      .product-item-wrapper {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 1088px;
        position: absolute;
        top: 200px;
        .product-item {
          h5 {
            font-family: PingFangSC-Regular;
            font-size: 24px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            margin-bottom: 18px;
          }
          img {
            width: 350px;
            height: 733px;
          }
        }
      }
    }
  }
</style>